// extracted by mini-css-extract-plugin
export default {"tile":"TileCard_tile__rMm8o"};